import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { Snapshot } from 'types';

const snapshotsAdapter = createEntityAdapter<Snapshot>();

export const slice = createSlice({
  name: 'snapshots',
  initialState: snapshotsAdapter.getInitialState({
    selectedSnapshotId: -1,
  }),
  reducers: {
    snapshotChanged: (state, { payload }) => {
      state.selectedSnapshotId = payload;
    },
    analyzerChanged: (state) => {
      state.selectedSnapshotId = -1;
    },
    setTemporaryBaseline: (state, { payload }) => {
      snapshotsAdapter.updateOne(state, {
        id: payload.snapshotId,
        changes: {
          baseline_trace: payload.baselineTrace,
          baseline_enabled: payload.baselineEnabled,
        },
      });
    },
    setTemporaryMarkerDeltas: (state, { payload }) => {
      snapshotsAdapter.updateOne(state, {
        id: payload.snapshotId,
        changes: {
          snapshot_marker_delta: payload.snapshotMarkerDeltas,
        },
      });
    },
  },
});

const reducer = slice.reducer;
export default reducer;

export const {
  snapshotChanged,
  setTemporaryBaseline,
  setTemporaryMarkerDeltas,
} = slice.actions;
